import React from "react";
import { Link, useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_HREF } from "../lib/team";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_prism-drop/artifacts/p0emyz4e_A1D7B4C2-09C7-4121-907C-32B19B4042A4.PNG";

const LINKS = [
  { to: "/servizi", label: "Servizi", match: ["/servizi"], testid: "nav-servizi" },
  { to: "/auto", label: "Marketplace", match: ["/auto", "/moto", "/veicolo"], testid: "nav-marketplace" },
  { to: "/giornale", label: "Articoli", match: ["/giornale"], testid: "nav-articoli" },
  { to: "/chi-siamo", label: "Team", match: ["/chi-siamo"], testid: "nav-team" },
];

// Header nero minimale: Servizi · Marketplace · Articoli · Team · WhatsApp.
export default function Navbar() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/vault-9821") || pathname.startsWith("/admin")) return null;

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50"
      style={{ background: "#000000", borderBottom: "1px solid rgba(255,255,255,0.06)" }}
      data-testid="navbar"
    >
      <div className="max-w-[1320px] mx-auto px-4 sm:px-8 h-[60px] sm:h-[64px] flex items-center justify-between gap-3 sm:gap-6">
        <Link to="/" className="flex items-center shrink-0" data-testid="nav-logo">
          <img src={LOGO_URL} alt="Garage Drops" className="h-8 sm:h-11 w-auto" />
        </Link>

        <div className="flex items-center gap-3 sm:gap-8 overflow-x-auto no-scrollbar">
          {LINKS.map((l) => {
            const on = l.match.some((m) => pathname.startsWith(m));
            return (
              <Link
                key={l.to}
                to={l.to}
                className="relative text-[12px] sm:text-[15px] tracking-wide whitespace-nowrap transition-colors duration-200 hover:text-white"
                style={{ color: on ? "#FF2800" : "rgba(255,255,255,0.82)", fontWeight: on ? 500 : 400 }}
                data-testid={l.testid}
              >
                {l.label}
              </Link>
            );
          })}
          <a
            href={WHATSAPP_HREF}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1.5 text-[12px] sm:text-[15px] tracking-wide whitespace-nowrap"
            style={{ color: "#25D366" }}
            aria-label="WhatsApp"
            data-testid="nav-whatsapp"
          >
            <MessageCircle size={16} strokeWidth={1.8} />
            <span className="hidden sm:inline">WhatsApp</span>
          </a>
        </div>
      </div>
    </nav>
  );
}
